import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { DELETE_WS } from "./actionTypes";
import { deleteWorkstationsSuccess, deleteWorkstationsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* deleteWorkstation({ payload: { ws, token, history } }) {
  try {
    const response = yield call(workstationAPI.deleteWorkstation, ws, token);
    yield put(deleteWorkstationsSuccess(response.message));
    history.go()
  } catch (error) {
    yield put(deleteWorkstationsError(error));
  }
}

export function* watchDeleteWorkstations() {
  yield takeEvery(DELETE_WS, deleteWorkstation);
}

function* getWorkstationsSaga() {
  yield all([fork(watchDeleteWorkstations)]);
}

export default getWorkstationsSaga;
